
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsVoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 28,
  viewBox: "0 0 20 28"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.24 6.464a5.24 5.24 0 0 0-10.48.001v7.417a5.24 5.24 0 1 0 10.48 0V6.464zm-9.194 7.418V6.464a3.953 3.953 0 0 1 7.908 0v7.418a3.954 3.954 0 1 1-7.908 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.775 12.121a.642.642 0 0 0-1.286 0v1.793a7.49 7.49 0 1 1-14.979 0v-1.793a.641.641 0 1 0-1.285 0v1.793a8.773 8.773 0 0 0 8.132 8.743v3.118H6.014a.643.643 0 0 0 0 1.286h7.972a.643.643 0 0 0 0-1.286h-3.343v-3.118a8.775 8.775 0 0 0 8.132-8.743v-1.793z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"28\" viewBox=\"0 0 20 28\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\".8\">\r\n            <g>\r\n                <g>\r\n                    <path d=\"M14.24 5.464C14.24 2.571 11.893.225 9 .225s-5.24 2.346-5.24 5.24v7.417c0 2.894 2.346 5.24 5.24 5.24s5.24-2.346 5.24-5.24V5.464zm-9.194 7.418V5.464c0-2.183 1.77-3.953 3.954-3.953 2.183 0 3.954 1.77 3.954 3.953v7.418c0 2.184-1.77 3.954-3.954 3.954-2.183 0-3.954-1.77-3.954-3.954z\" transform=\"translate(-147 -470) translate(45 465) translate(103 6)\"/>\r\n                    <path d=\"M17.775 11.121c0-.355-.288-.642-.643-.642-.355 0-.643.287-.643.642v1.793c0 4.137-3.353 7.49-7.489 7.49-4.136 0-7.49-3.353-7.49-7.49v-1.793c0-.355-.287-.642-.642-.642-.355 0-.643.287-.643.642v1.793c.004 4.594 3.55 8.407 8.132 8.743v3.118H5.014c-.355 0-.643.288-.643.643 0 .355.288.643.643.643h7.972c.355 0 .643-.288.643-.643 0-.355-.288-.643-.643-.643H9.643v-3.118c4.581-.336 8.128-4.15 8.132-8.743v-1.793z\" transform=\"translate(-147 -470) translate(45 465) translate(103 6)\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-voice.cdf29816aa899ef6464e9f07708af901.svg"),
        {
          React: SvgIconsVoice,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      